import { render, staticRenderFns } from "./IndentOrderDetail.vue?vue&type=template&id=65544717&scoped=true&"
import script from "./IndentOrderDetail.vue?vue&type=script&lang=js&"
export * from "./IndentOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./IndentOrderDetail.vue?vue&type=style&index=0&id=65544717&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65544717",
  null
  
)

export default component.exports